// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArrayOfStrings = (arr: any): arr is string[] =>
  Array.isArray(arr) && !arr.some(e => typeof e !== 'string');

export const removeArrayDuplicatesByKey = <T>(array: T[], key: string): T[] => {
  const existingKeys = new Set<string>();
  return array.filter(item => {
    if (existingKeys.has(item[key])) {
      return false;
    }
    existingKeys.add(item[key]);
    return true;
  });
};

export const removeArrayDuplicates = <T>(array: T[], key: string) => {
  const set = new Set();
  return array.filter(obj => {
    if (!set.has(obj[key])) {
      set.add(obj[key]);
      return true;
    }
    return false;
  });
};

export const arrayHasPrimitiveValues = (array: unknown[]): boolean => {
  if (!array) {
    throw new Error('please pass an array');
  }

  return !(array[0] instanceof Object);
};

export const removeArrayDuplicatesPrimitive = <T>(array: T[]) => {
  return [...new Set(array)];
};
